module.exports = __webpack_public_path__ + "img/8_hillstate.43c07cbf.png";